import React, { Component } from "react";
import "react-datetime/css/react-datetime.css";
import { Redirect } from "react-router-dom";
import Comm from "../comm/comm";
import Context from "../context/context";
import Translation from "../translation/translation";

class SalesReportResult extends Component {
    PackingListsPage;
    PageSize;
    constructor(props) {
        super(props);

        if (!Comm.ValidSession()) return;

        this.PackingListsPage = 0;
        this.PageSize = 10;
        if (!Context.IsLogged()) {
            return;
        }
        // var sid = Context.GetContext().Sid; // not used below
        var data = JSON.parse(this.props.match.params.data);
        var pl;
        if (data.operation === "and") {
            pl = Comm.PackingListsByPartnersAndGoods(data);
        } else {
            pl = data.partnerorgood ? Comm.PackingListsByPartners(data) : Comm.PackingListsByGoods(data);
        }

        this.state = {
            Data: data,
            PackingListQueryResult: pl,
        };

        this.ShowPackingList = this.ShowPackingList.bind(this);
        this.ShowQueryResult = this.ShowQueryResult.bind(this);
    }

    ShowQueryResult(pageInc) {
        var data = this.state.Data;

        data.page = data.page + pageInc;

        var pl;
        if (data.operation === "and") {
            pl = Comm.PackingListsByPartnersAndGoods(data);
        } else {
            pl = data.partnerorgood ? Comm.PackingListsByPartners(data) : Comm.PackingListsByGoods(data);
        }

        this.setState({
            Data: data,
            PackingListQueryResult: pl,
        });

        //alert(JSON.stringify(pl));
    }

    ShowPackingList(id) {
        window.open("/displaypackinglist/" + id);
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }

        if (Context.RenderNotOK(this.props.history)) return null;

        return Context.HasRight("rsalesreport") ? (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("sales")}</div>
                <div className="panel-body">
                    <div className="col-md-12">
                        <div className="col-md-12">
                            {this.state.PackingListQueryResult &&
                            this.state.PackingListQueryResult.packing_lists ? (
                                <table className="table table-striped">
                                    <tbody>
                                        {this.state.PackingListQueryResult.packing_lists.map(
                                            (item, index) => (
                                                <tr key={item.id + index}>
                                                    <td>{item.date}</td>
                                                    <td>{item.name}</td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn btn-default"
                                                            onClick={() => this.ShowPackingList(item.id)}
                                                        >
                                                            {Translation.Trans("show")}
                                                        </button>
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                    </tbody>
                                </table>
                            ) : null}
                        </div>
                        {this.state.PackingListQueryResult ? (
                            <div className="col-md-1">
                                {this.state.Data.page > 0 ? (
                                    <button
                                        type="button"
                                        className="btn btn-default"
                                        onClick={() => this.ShowQueryResult(-1)}
                                    >
                                        &lt;&lt;
                                    </button>
                                ) : null}
                            </div>
                        ) : null}
                        {this.state.PackingListQueryResult ? (
                            <div className="col-md-1">
                                {(this.state.Data.page + 1) * this.state.Data.pagesize <
                                this.state.PackingListQueryResult.count ? (
                                    <button
                                        type="button"
                                        className="btn btn-default"
                                        onClick={() => this.ShowQueryResult(1)}
                                    >
                                        &gt;&gt;
                                    </button>
                                ) : null}
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        ) : (
            <div>{Translation.Trans("noRights")}</div>
        );
    }
}

export default SalesReportResult;



// WEBPACK FOOTER //
// ./src/pages/salesreportresult.js